import Component from '../core/Component'
import scrollToElement from '../services/Viewport/scrollToElement'

export default class CalendarFormRegistrationDateSetter extends Component {

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()

        const form = document.getElementById('calendar-form-registration')

        if (!form) {
            return
        }

        const formComponent = Component.getFromElement(form)

        if (formComponent) {
            formComponent.show().setValue('date', this.element.dataset.id)
            scrollToElement(form)
        }

    }
}